import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useConstHandler } from '../../hooks/useConstFunction';
import { appSlice } from '../../store/slices';
import RootModalSwitch from './RootModalSwitch';

const RootModals = memo(function RootModals() {
	const modals = useSelector(state => state?.app?.modals);
	const location = useLocation();
	const dispatch = useDispatch();

	const onLocationChangeHandler = useConstHandler(() => {
		if (modals.length > 0) {
			dispatch(appSlice.actions.closeAllModals());
		}
	});

	useEffect(() => {
		onLocationChangeHandler();
	}, [location, onLocationChangeHandler]);

	return (
		<>
			{modals.map(modal => (
				<RootModalSwitch modal={modal} key={modal.id} />
			))}
		</>
	);
});

export default RootModals;
